import React from "react";
import "./MasInformacion.css"
import {FaWhatsapp} from 'react-icons/fa';
function MasInfo() {
    return (<>
        <div className="MasInfo-wrap">

            <div className="MasInfo-Contactanos">
                <div class="MasInfoWhats">
                    <a href="https://wa.me/6681316676" target="_blank"><FaWhatsapp id="wappSize" color="green"/></a>
                </div>
                <div className="MasInfoTxt"><h4>CONTACTANOS Y SOLICITA MÁS INFORMACION O COMPRA EN LINEA Y TU PEDIDO LLEGARÁ A DOMICILIO.</h4>
                </div>
            </div>
            <div className="MasInfo-VerProductos">
                
                <h3 className="Buscar">Buscar Producto</h3>
            </div>
        </div>
    </>
    );
}
export default MasInfo